<template>
  <div style="min-height: 750px;">
    <b-row style="margin: 3px;">
      <b-col sm="12" lg="6">
        <strong>
              {{ p_userShopBundleDiscountClientID ? '' : StoreLangTranslation.data['new_data'][StoreLang] }}
        </strong>
        <template v-if="d_loading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
      </b-col>
      <b-col sm="12" lg="6" style="text-align: right;">
        <template v-if="!d_loading">
          <template v-if="d_saveLoading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <b-button variant="outline-success" @click="f_userShopBundleDiscountRecord()">
              {{ StoreLangTranslation.data['save'][StoreLang] }}
            </b-button>
          </template>
        </template>
      </b-col>
    </b-row>

    <b-row v-if="!d_loading && d_userShopBundleDiscountWdm" style="overflow-x: hidden; overflow-y: auto; height: 750px;">
      <b-col sm="12" lg="12">
        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row>
            <b-col sm="12" lg="8">
              <h3>
                <i class="fa fa-calculator"></i>
                {{ StoreLangTranslation.data['discount_general_settings'][StoreLang] }}
              </h3>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleDiscountWdm['0']['parameters']['0']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleDiscountData.status">
              <option v-for="(op, op_index) in d_userShopBundleDiscountWdm['0']['parameters']['0'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleDiscountWdm['0']['parameters']['5']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-form-input type="text" v-model="d_userShopBundleDiscountData.discount_name[lang.label]"></b-form-input>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleDiscountWdm['0']['parameters']['6']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input type="number" v-model="d_userShopBundleDiscountData.discount_percent"></b-form-input>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleDiscountWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input type="date" v-model="d_userShopBundleDiscountData.discount_start_date"></b-form-input>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleDiscountWdm['0']['parameters']['2']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input type="date" v-model="d_userShopBundleDiscountData.discount_end_date"></b-form-input>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleDiscountWdm['0']['parameters']['3']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userShopBundleDiscountData.discount_type">
              <option v-for="(op, op_index) in d_userShopBundleDiscountWdm['0']['parameters']['3'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleDiscountWdm['0']['parameters']['4']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input type="text" v-model="d_userShopBundleDiscountData.institution_name"></b-form-input>
          </b-col>
        </b-row>

      </b-col>
    </b-row>

  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as WTable2
} from '@/components/widgets/WTable2';
import { mapGetters } from 'vuex';
export default {
  name: 'ShopBundleDiscountRecord',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    PageInfo,
    WTable2,
  },
  props: {
    p_userShopClientID: {
      type: String,
      required: true
    },
    p_userShopBundleClientID: {
      type: String,
      required: true
    },
    p_userShopBundleDiscountClientID: {
      type: String,
      required: true
    },
    f_userShopBundleDiscountList: {
      type: Function,
      required: true
    },
  },
  data () {
    return {
      d_loading: false,
      d_saveLoading: false,
      d_user: '',
      d_frontendClientID: '',
      d_userShopClientID: '',
      d_userShopBundleClientID: '',
      d_userShopBundleDiscountClientID: '',
      d_frontendList: [],
      d_userShopBundleDiscountWdm: '',
      // d_usrShpBundWdm: '',

      d_userShopBundleDiscountData: {
        'status': '0',
        'discount_start_date': '',
        'discount_end_date': '',
        'discount_type': '0',
        'institution_name': '',
        'discount_name': {},
      },
      ClsUser: ClsUser,
      d_showBundleModal: false,
      d_editBundleModal: false,
      d_modalLoading: false,
      d_datasetViewLoading: false,
      d_saveLoading: false,
      d_datasetWTable: '',
      d_excelFile: null,
      d_excelFileBase64: '',
      d_excelFileName: '',
    };
  },
  created: function () {
    this.d_loading = true;
    // ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_usrShpBundWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shp_bund_discount').then(resp_wdm_data => { this.d_userShopBundleDiscountWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.p_userShopClientID;
    this.d_userShopBundleClientID = this.p_userShopBundleClientID;
    this.d_userShopBundleDiscountClientID = this.p_userShopBundleDiscountClientID;

    // if (this.$route.query.user_shop_client_id) {
    //   this.d_userShopClientID = this.$route.query.user_shop_client_id;
    // }

    let auth_eligible = false;
    let user_perm_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligible = ClsUser.f_checkUserAuth([this.d_userShopClientID + '_shop_admin', this.d_userShopClientID + '_shop_bundle_add_edit'],'with_id');
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && (user_perm_eligible || user_perm_eligibleGeneral) ) {
      if (this.$route.query.user_shop_bundle_client_id) {
        this.d_userShopBundleClientID = this.$route.query.user_shop_bundle_client_id;
      }
      if (this.$route.query.user_shop_bundle_discount_client_id) {
        this.d_userShopBundleDiscountClientID = this.$route.query.user_shop_bundle_discount_client_id;
      }
      if (this.d_userShopBundleDiscountClientID) {
        this.f_userShopBundleDiscountGet();
      }
      if (!this.d_userShopClientID) {
        alert(this.StoreLangTranslation.data['shop_is_not_selected'][this.StoreLang]);
        this.f_goToShopList();
      }
      if (!this.d_userShopBundleClientID) {
        alert(this.StoreLangTranslation.data['bundle_is_not_selected'][this.StoreLang]);
        this.f_goToShopList();
      }
      if (!this.d_userShopBundleDiscountClientID) {
        this.f_langEligibleParameterProcess();
        this.d_loading = false;
      }
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
  },
  methods: {
    f_goToShopList: function () {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_list'), query: {} });
    },
    f_langEligibleParameterProcess: function () {
      let lang_eligible_variables = ['discount_name'];
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          if (!this.d_userShopBundleDiscountData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
            this.d_userShopBundleDiscountData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
          }
        }
      }
    },
    f_userShopBundleDiscountRecord: function () {
      let query = 'user_client_id=' + this.d_user.username;
      let data = {
        'discount_data' : this.d_userShopBundleDiscountData,
      };
      if (this.d_userShopClientID) {
        query += '&user_shop_client_id=' + this.d_userShopClientID;
      }
      if (this.d_userShopBundleClientID) {
        query += '&user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      }
      if (this.d_userShopBundleDiscountClientID) {
        query += '&user_shop_bundle_discount_client_id=' + this.d_userShopBundleDiscountClientID;
      }
      // console.log('data: ',data)
      this.d_saveLoading = true;
      if (this.d_userShopBundleDiscountClientID) {
        ServiceFunctions.user_shop_bundle_discount_edit(query, data)
          .then(resp => {
            this.d_saveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      } else {
        ServiceFunctions.user_shop_bundle_discount_new(query, data)
          .then(resp => {
            this.d_saveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              this.f_userShopBundleDiscountList();
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    },
    f_userShopBundleDiscountGet: function () {
      this.d_loading = true;
      let query = 'user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      query += '&data_type=value_mode';
      query += '&user_shop_client_id=' + this.d_userShopClientID;
      query += '&user_shop_bundle_discount_client_id=' + this.d_userShopBundleDiscountClientID;
      query += '&user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shop_bundle_discount_get(query, data)
        .then(resp => {
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.data) {
              this.d_userShopBundleDiscountData = resp.data.data;
              this.f_langEligibleParameterProcess();
              // this.f_userShopBundleGet();
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {}
};

</script>

